import PropTypes from "prop-types"
import { size } from "lodash"
import { Work } from "@mui/icons-material"
import EditPortfolio from "modules/edit-portfolio"
import { PERMISSION_LEVEL, ROLE } from "helpers/shapes"
import { PERMISSION_LEVELS, hasPermission } from "helpers/permissions"
import Resource from "../resource"
import { LinkAction, ButtonAction } from "../card-actions"
import { renderAction } from "../../helpers"
import saveRecentResources from "hocs/saveRecentResources"
import { getPortfolioMenuItems } from "modules/portfolio-root/selectors/menu"

export default function Portfolio({
  handlers,
  resource,
  permissionLevel,
  models,
  openDialog,
  trackResourceEvent,
  toggleFavorite,
  account,
  linkedToAlphaTheory,
  role,
  isOpPro,
  dispatch,
  intradayAccountEnabled,
}) {
  const handleSavePortfolio = (data, upload) => {
    handlers.updatePortfolio(resource, data, upload)
  }

  const openEditDialog = () => {
    const { id } = resource
    const EditPortfolioWithRecentResources = saveRecentResources(EditPortfolio, "portfolioId")

    openDialog({
      title: "Edit Portfolio",
      content: <EditPortfolioWithRecentResources
        portfolioId={id}
        linkedToAlphaTheory={linkedToAlphaTheory}
        savePortfolio={handleSavePortfolio}
      />,
    })
  }

  const trackActionClick = (type, action) => {
    return () => {
      trackResourceEvent({
        trackType: "resources-secondary-link",
        trackPayload: {
          actionType: type,
          resourceType: "portfolio",
        },
      })
      if (action) action()
    }
  }

  const computeAction = () => {
    const { refresh, noData, id, description, alias } = resource
    const canEditPortfolio = role === "admin" || hasPermission(permissionLevel, PERMISSION_LEVELS.WRITE)
    const noModels = !size(models)

    // getCardAction displays only the first valid button
    return renderAction([
      {
        condition: canEditPortfolio && noData && !refresh,
        render: <LinkAction to={`/${account}/p/${id}/upload`} onClick={trackActionClick("upload")} disabled={noModels}>Upload positions</LinkAction>,
      },
      {
        condition: canEditPortfolio && !description,
        render: <ButtonAction onClick={trackActionClick("description", openEditDialog)} disabled={noModels}>Add description</ButtonAction>,
      },
      {
        condition: !noData && !isOpPro,
        render: <LinkAction to={`/${account}/p/${alias || id}/rebalance/experiments`} onClick={trackActionClick("experiments")} disabled={noModels}>View experiments</LinkAction>,
      },
    ])
  }

  return <Resource {...{
    account,
    trackResourceEvent,
    toggleFavorite,
    url: `/${account}/p/${resource.alias || resource.id}`,
    resource,
    resourceType: "portfolio",
    resourceIcon: <Work />,
    permissionLevel,
    action: computeAction(),
    menuItems: getPortfolioMenuItems(account, resource, models, intradayAccountEnabled),
    models,
    isOpPro,
    dispatch,
  }}
  />
}

Portfolio.propTypes = {
  handlers: PropTypes.object.isRequired,
  resource: PropTypes.object.isRequired,
  permissionLevel: PERMISSION_LEVEL.isRequired,
  models: PropTypes.object.isRequired,
  openDialog: PropTypes.func.isRequired,
  trackResourceEvent: PropTypes.func.isRequired,
  toggleFavorite: PropTypes.func.isRequired,
  account: PropTypes.string.isRequired,
  linkedToAlphaTheory: PropTypes.bool,
  isOpPro: PropTypes.bool.isRequired,
  role: ROLE.isRequired,
  dispatch: PropTypes.func,
  intradayAccountEnabled: PropTypes.bool,
}
